import { render, staticRenderFns } from "./MessageQueueTable.vue?vue&type=template&id=00d72757&"
import script from "./MessageQueueTable.vue?vue&type=script&lang=babel&"
export * from "./MessageQueueTable.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports